import { useQuery } from '@tanstack/react-query';
import { useApiClients } from '../../client/api/useApiClient';
import Statistics from '../../views/Statistics';
import {
  GetStatisticResponseChartsDto,
  GetStatisticResponseDto,
  StatisticsControllerGetStatisticsInsightCorrectiveActionOverviewEnum,
  StatisticsControllerGetStatisticsInsightIncidentTypeActiveEnum,
  StatisticsControllerGetStatisticsInsightSeverityActiveEnum,
} from '@EHSNavigator/backend';
import { useSearchParams } from 'react-router';
import moment from 'moment';
import Loader from '../../components/Loader';

export default function StatisticsPage() {
  const { StatisticsApi } = useApiClients();
  const [searchParams] = useSearchParams();
  const year = searchParams.get('year') ?? moment().format('YYYY');
  const severityActive = searchParams.get('severityActive') ?? 'year';
  const incidentSeverityMonth =
    searchParams.get('incidentSeverityMonth') ?? moment().format('M');
  const incidentTypeActive = searchParams.get('incidentTypeActive') ?? 'year';
  const incidentTypeMonth =
    searchParams.get('incidentTypeMonth') ?? moment().format('M');
  const correctiveActionOverview =
    searchParams.get('correctiveActionOverview') ?? 'No-Filter';

  const { data, isPending } = useQuery<
    GetStatisticResponseChartsDto,
    Error,
    any
  >({
    queryKey: [
      'statistics-charts',
      Number(year),
      severityActive,
      Number(incidentSeverityMonth),
      incidentTypeActive,
      Number(incidentTypeMonth),
      correctiveActionOverview,
    ],
    queryFn: async () => {
      const response =
        await StatisticsApi?.statisticsControllerGetStatisticsInsight({
          year: Number(year),
          severityActive:
            severityActive as StatisticsControllerGetStatisticsInsightSeverityActiveEnum,
          incidentSeverityMonth: Number(incidentSeverityMonth),
          incidentTypeActive:
            incidentTypeActive as StatisticsControllerGetStatisticsInsightIncidentTypeActiveEnum,
          incidentTypeMonth: Number(incidentTypeMonth),
          correctiveActionOverview:
            correctiveActionOverview as StatisticsControllerGetStatisticsInsightCorrectiveActionOverviewEnum,
        });
      return response?.data || [];
    },
  });
  const {
    data: stats,
    isLoading,
    isRefetching,
  } = useQuery<GetStatisticResponseDto, Error, any>({
    queryKey: ['statistics-stats'],
    queryFn: async () => {
      const response = await StatisticsApi.statisticsControllerGetStatistics();
      return response?.data || [];
    },
  });

  if (isLoading || isRefetching) {
    return <Loader />;
  }

  return (
    <div className="relative flex w-full flex-1 flex-col px-15 pt-14 pb-10 md:px-25 lg:pr-14 lg:pb-20 lg:pl-8">
      <Statistics
        data={data}
        isLoading={isPending}
        stats={stats}
        params={{
          severityActive:
            severityActive as StatisticsControllerGetStatisticsInsightSeverityActiveEnum,
          incidentSeverityMonth: Number(incidentSeverityMonth),
          year: Number(year),
          incidentTypeActive:
            incidentTypeActive as StatisticsControllerGetStatisticsInsightIncidentTypeActiveEnum,
          incidentTypeMonth: Number(incidentTypeMonth),
          correctiveActionOverview:
            correctiveActionOverview as StatisticsControllerGetStatisticsInsightCorrectiveActionOverviewEnum,
        }}
      />
    </div>
  );
}
